import { OfferRequest } from "@duffel/api/booking/OfferRequests/OfferRequestsTypes";
import { Filters } from "./filter-results";
import { getAirlines } from "./getAirlines";

export function getInitialFilterValues(offerRequest: OfferRequest): Filters {
  return {
    airlines: getAirlines(offerRequest),
    stops: "any",
    times: {
      departure: [0, 1440],
      arrival: [0, 1440],
    },
  };
}
;
import "/Users/jekri/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";